
  import * as contentfulRuntime$sgrL5NoRb2u5ZOpC0V_J7XMM65fTW_45o1CMdG__456ihU4 from '/app/node_modules/@nuxt/image/dist/runtime/providers/contentful'
import * as ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 992,
    "xl": 1200,
    "xxl": 1400,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "images.ctfassets.net",
    "grilldburgerbosssa.blob.core.windows.net"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "webp"
  ]
},
    providers: {
        ['contentful']: { provider: contentfulRuntime$sgrL5NoRb2u5ZOpC0V_J7XMM65fTW_45o1CMdG__456ihU4, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: undefined }
    }
  }
